import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { formatNumber } from "src/app/_helpers/must-match.validator";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tds-report',
  templateUrl: './tds-report.component.html',
  styleUrls: ['./tds-report.component.scss'],
  styles:  [`
  :host ::ng-deep .p-datatable-gridlines p-progressBar {
    width: 100%;
  }

  @media screen and (max-width: 960px) {
    :host
      ::ng-deep
      .p-datatable.p-datatable-customers.rowexpand-table
      .p-datatable-tbody
      > tr
      > td:nth-child(6) {
      display: flex;
    }
  }
`],
providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class TdsReportComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  loading: boolean;
  paginationOption;
  minYear = environment.minYear;
  submitted: boolean = false;
  rsubmitted: boolean= false;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  downloadFlg: boolean;
  startDate: any;
  endDate: any;
  searchby: any;
  searchBy: { label: string; value: string; }[];
  calvalue: null;
  ucalvalue: null;
  errorMessage: any;
  tdsReport: any = [];
  walletlist: any = [];
  totalRecords: any = 0;

  constructor(private userWalletService: UserWalletService) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: "Credit/Withdraw Date", value: "created_at" }
    ];
    this.downloadFlg = false;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.dt.filter("", "pan", "contains");
    this.dt.filter("", "tdsSection", "contains");
    this.dt.filter("", "tdsDeductedAmount", "contains");
    this.dt.filter("", "deductee", "contains");
    this.dt.filter("", "tdsAmount", "contains");
    this.dt.filter("", "withdraw_date", "dateIs");
    this.dt.filter("", "credited_date", "dateIs");
    this.dt.filter("", "withdrawId", "contains");
    this.dt.filter("", "tdsRate", "contains");
    this.calvalue = null;
    this.ucalvalue = null;
    this.dt.sortField = null;
    this.dt._first = 0;
    this.dt._rows = 10;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.tdsList(this.lastTableLazyLoadEvent);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  tdsList(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    const showAllRows = event?.rows && typeof event.rows === "object" && (event.rows as any).showAll;
    if (showAllRows) {
      pagenumber = 1;
    } else if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (showAllRows) {
      rows = this.totalRecords;
    } else if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }  
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["deductee"] != undefined) {
      params += "&filterByDeductee=" + event.filters["deductee"].value;
    }
    if (event.filters != undefined && event.filters["tdsRate"] != undefined) {
      params += "&filterBytdsRate=" + event.filters["tdsRate"].value;
    }
    if (event.filters != undefined && event.filters["pan"] != undefined) {
      params += "&filterByPan=" + event.filters["pan"].value;
    }
    if (event.filters != undefined && event.filters["tdsSection"] != undefined) {
      params += "&filterBytdsSection=" + event.filters["tdsSection"].value;
    }
    if (event.filters != undefined && event.filters["tdsAmount"] != undefined) {
      params += "&filterBytdsAmount=" + event.filters["tdsAmount"].value;
    }
    if (event.filters != undefined && event.filters["withdrawId"] != undefined) {
      params += "&filterByWithdrawId=" + event.filters["withdrawId"].value;
    }
    if (event.filters != undefined && event.filters["tdsDeductedAmount"] != undefined) {
      params += "&filterBytdsDeductedAmount=" + event.filters["tdsDeductedAmount"].value;
    }
    const selectedDateFilter = event.filters?.["withdraw_date"]?.value || event.filters?.["credited_date"]?.value;
    if (selectedDateFilter) {
      params += "&filterByCreatedAt=" + moment(selectedDateFilter).format("YYYY-MM-DD");
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false && !showAllRows) {
        if (params != undefined && params != "") {
            query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
        } else {
            query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
        }
    } else {
        if (params != undefined && params != "") {
            query += params;
        }
    } 
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletService.getContestUserTDSreport(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.loading = false;
      if (this.downloadFlg === true) {
        this.contestUserTDSreport(data.data.items);
      } else {
      this.walletlist = data.data.items;
      this.totalRecords = data.data.totalCount;
      }
    },
    (err) => {
      this.errorMessage = err.error.message;
    });
  }

  contestUserTDSreport(data){
    this.loading = false;
    this.tdsReport = data;
    this.downloadFlg = false;
    var downloadTdsReport = this.tdsReport;
    let contestUserTDSData = [];
    downloadTdsReport.forEach(function (item) {                  
      contestUserTDSData.push({
        "TDS Section": item.tdsSection||"",
        "Pan Number": item.pan || "",
        "Name of Deductee": item.deductee,
        "Withdrawn Amount Date": moment(item.created_at).format('DD-MM-YYYY'),
        "Withdrawn ID":item.withdrawId,
        "Date on which Amount Paid/Credited": moment(item.created_at).format('DD-MM-YYYY'),
        "Rate at which TDS Deducted":item.tdsRate,
        "Amount of Payment/ Credit": formatNumber(item.tdsDeductedAmount),
        "TDS Deducted Amount": formatNumber(item.tdsAmount),
      });            
    });
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(contestUserTDSData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });
        this.saveAsExcelFile(excelBuffer, `TDSReport`);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  addColumns() {
    this.hide = false;
  }

  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
